import * as yup from 'yup';

import { isOverridden } from 'features/cluster/workload-optimization/_woop-settings/_validations/is-overridden';
import {
  autoscalerModeValidationSchema,
  cpuAndMemoryRangeValidationSchema,
  excludedContainersValidationSchema,
  hpaConverterValidationSchema,
  jvmAutoInstrumentValidationSchema,
  jvmMemoryOptimizationValidationSchema,
  lookbackPeriodValidationSchema,
  makeCpuAndMemoryConstraintsV2ValidationSchema,
  memoryGrowthDetectionValidationSchema,
  optimizationThresholdValidationSchema,
  optimizedResourcesValidationSchema,
  predictiveScalingValidationSchema,
  resourceLimitsValidationSchema,
  rolloutBehaviorValidationSchema,
  stallDetectionValidationSchema,
  startupMetricsValidationSchema,
} from 'features/cluster/workload-optimization/_woop-settings/_validations/vpa';

import { VerticalRightsizingPolicyFormModel } from '../_types';

export const vpaValidationSchema = yup.object({
  applyType: isOverridden(
    yup.object({ value: autoscalerModeValidationSchema })
  ),
  downscaling: isOverridden(
    yup.object({ value: autoscalerModeValidationSchema })
  ),
  memoryEvent: isOverridden(
    yup.object({ value: autoscalerModeValidationSchema })
  ),
  antiAffinity: isOverridden(
    yup.object({ value: autoscalerModeValidationSchema })
  ),
  recommendationPercentile: isOverridden(cpuAndMemoryRangeValidationSchema),
  optimizedResources: isOverridden(optimizedResourcesValidationSchema),
  predictiveScaling: isOverridden(predictiveScalingValidationSchema),
  optimizationThreshold: isOverridden(optimizationThresholdValidationSchema),
  startupMetrics: isOverridden(startupMetricsValidationSchema),
  lookbackPeriod: isOverridden(lookbackPeriodValidationSchema),
  excludedContainers: isOverridden(excludedContainersValidationSchema),
  overhead: isOverridden(cpuAndMemoryRangeValidationSchema),
  memoryGrowthDetection: isOverridden(memoryGrowthDetectionValidationSchema),
  stallDetection: isOverridden(stallDetectionValidationSchema),
  customMetrics: yup
    .array()
    .of(
      isOverridden(
        yup.object({
          containerName: yup.string().required(),
          jvmMemoryOptimization: jvmMemoryOptimizationValidationSchema,
          jvmAutoInstrument: jvmAutoInstrumentValidationSchema,
        })
      )
    )
    .required(),
  workloadConstraints: yup
    .array()
    .of(
      isOverridden(
        yup
          .object({ containerName: yup.string().required() })
          .concat(makeCpuAndMemoryConstraintsV2ValidationSchema())
      )
    )
    .required(),
  resourceLimits: isOverridden(resourceLimitsValidationSchema),
  rolloutBehavior: isOverridden(rolloutBehaviorValidationSchema),
  hpaConverter: isOverridden(hpaConverterValidationSchema),
}) satisfies yup.ObjectSchema<VerticalRightsizingPolicyFormModel>;
